import { useBreakpoints } from "@shared/hooks/useBreakpoints/useBreakpoints";
import { useCatalogSearch } from "@shared/hooks/useCatalogSearch/useCatalogSearch";

export const useProductCardsColumnWidth = (noFilterColumn?: boolean) => {
  const { activeSearchType } = useCatalogSearch();
  const { desktop, tablet, width } = useBreakpoints();
  const renderLessCards = width <= 1439;
  const isSearchFilterOpen = !noFilterColumn && activeSearchType === "filters";

  if (isSearchFilterOpen) {
    if (renderLessCards) {
      return 6;
    }

    return 4;
  }

  if (renderLessCards && tablet.greaterThan) return 4;
  if (desktop.lessThan) return 6;

  return 3;
};
